import { request } from './http';

const shouldFallbackToLegacyReservation = (error) => {
  const message = String(error?.message || '').toLowerCase();
  return (
    message.includes('createReservation'.toLowerCase())
    || message.includes('no se pudo conectar al endpoint de cloud functions desplegado')
    || message.includes('no se pudo conectar al emulador de cloud functions')
    || message.includes('no está disponible en el backend')
    || message.includes('failed to fetch')
  );
};

const createReservation = async (reservation) => {
  try {
    return await request('createReservation', {
      body: reservation
    });
  } catch (error) {
    if (!shouldFallbackToLegacyReservation(error)) {
      throw error;
    }

    const legacyResponse = await request('makeReservation', {
      body: reservation
    });

    return {
      ok: true,
      message: legacyResponse?.success || legacyResponse?.message || 'Reservación creada con éxito.'
    };
  }
};

const acceptReservationTerms = (reservationId) => request('acceptReservationTerms', {
  body: { reservationId }
});

const verifyReservationPayment = (reservationId, checkoutId, paymentId = '') => request('verifyReservationPayment', {
  body: { reservationId, checkoutId, paymentId }
});

const getReservationPaymentStatus = (reservationId) => request('getReservationPaymentStatus', {
  body: { reservationId }
});

export { createReservation, acceptReservationTerms, verifyReservationPayment, getReservationPaymentStatus };
